import { render, staticRenderFns } from "./panel_living.vue?vue&type=template&id=1f01d83e&scoped=true&"
import script from "./panel_living.vue?vue&type=script&lang=js&"
export * from "./panel_living.vue?vue&type=script&lang=js&"
import style0 from "./panel_living.vue?vue&type=style&index=0&id=1f01d83e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01d83e",
  null
  
)

export default component.exports